(function (app) {
    app.constant("policyStages",
    [
        { PolicyStageId: 1, PolicyStageName: "Application Signed" },
        { PolicyStageId: 2, PolicyStageName: "Received at FIG" },
        { PolicyStageId: 3, PolicyStageName: "Submitted to Carrier" },
        { PolicyStageId: 4, PolicyStageName: "Pending" },
        { PolicyStageId: 6, PolicyStageName: "Issued" },
        { PolicyStageId: 7, PolicyStageName: "Inforce" },
        { PolicyStageId: 8, PolicyStageName: "Cancelled" },
    ]);
})(window.app); //jshint ignore:line